import Login from "views/Login";
import Home from "views/Home";

import Operational from "views/Dashboards/Operational";

import Users from "views/Users";
import CreateUser from "views/Users/CreateUser";
import ViewUser from "views/Users/ViewUser";
import EditUser from "views/Users/EditUser";

import Lives from "views/Lives";
import CreateLife from "views/Lives/CreateLife";
import ViewLife from "views/Lives/ViewLife";
import EditLife from "views/Lives/EditLife";

import Glucose from "views/Glucose";

import Calendar from "views/Events/Calendar";
import Schedules from "views/Events/Schedules";

import Event from "views/Events/Event";
import Reports from "views/Reports";
import ReleaseNotes from "views/ReleaseNotes";
import HighRiskLives from "views/HighRiskLives";
import ResetPassword from "views/ResetPassword";
import AutoRegister from "views/AutoRegister";

const routes = [
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/resetar/:token",
        element: <ResetPassword />
    },
    {
        path: "/cadastro",
        element: <AutoRegister />
    },
    // DASHBOARDS
    {
        path: "/dashboards/operacional",
        element: <Operational />
    },
    // USERS
    {
        path: "/administracao/usuarios",
        element: <Users />
    },
    {
        path: "/administracao/usuarios/cadastrar",
        element: <CreateUser />
    },
    // {
    //     path: "/administracao/usuarios/:id",
    //     element: <ViewUser />
    // },
    {
        path: "/administracao/usuarios/:id/editar",
        element: <EditUser />
    },
    // REPORTS
    // {
    //     path: "/relatorios",
    //     element: <Reports />
    // },
    // LIVES
    {
        path: "/administracao/vidas",
        element: <Lives highRisk={false} />
    },
    {
        path: "/administracao/alto-risco",
        element: <HighRiskLives />
    },
    // {
    //     path: "/administracao/vidas/cadastrar",
    //     element: <CreateLife />
    // },
    {
        path: "/administracao/vidas/:id",
        element: <ViewLife />
    },
    {
        path: "/administracao/alto-risco/:id",
        element: <ViewLife />
    },
    // {
    //     path: "/administracao/vidas/:id/editar",
    //     element: <EditLife />
    // },

    // GLUCOSE
    {
        path: "/administracao/monitoramento",
        element: <Glucose />
    },
    // EVENTS
    {
        path: "/eventos/calendario",
        element: <Calendar />
    },
    {
        path: "/eventos/compromissos",
        element: <Schedules />
    },
    {
        path: "/eventos/:id",
        element: <Event />
    },
    // EVENTS
    {
        path: "/notas",
        element: <ReleaseNotes />
    },
    // OTHER
    {
        path: "/",
        element: <Home />
    },
    {
        path: "/*",
        element: <Home />
    },
    {
        name: "login",
        path: "/login",
        component: Login,
        roles: [],
    },
    {
        name: "",
        path: "/*",
        component: Login,
        roles: [],
    },
]

export default routes